import { combineReducers } from "redux";
import Slice from "./Handleslice"
// here we can combine the multiple reduce in single root if we have complex application.
const rootReducer=combineReducers({data:Slice});
export default rootReducer;